<template>
  <b-overlay :show="show" rounded="sm">
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="8">
              <h3 tabindex="0">Delegação</h3>
            </b-col>
            <b-col md="4">
              <b-button block variant="primary" @click="abrirModalCadastrar">
                <i class="fa fa-plus"></i>&nbsp;&nbsp;<span>Cadastrar Participante</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-form-group label="Nome:">
                <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group label="Período - Data Início:" for="data_inicio">
                <b-form-input id="data_inicio" v-model="filtros.data_inicio" v-mask="'##/##/####'" type="text"
                  class="form-control" placeholder="Data Início" />
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Periodo - Data Fim:" for="data_final">
                <b-form-input id="data_final" v-model="filtros.data_final" v-mask="'##/##/####'" type="text"
                  class="form-control" placeholder="Data Fim" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <b-button block @click="limpar">
                <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
              </b-button>
            </b-col>
            <b-col sm="2">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>
            <b-col v-show="exibe_importacao" offset-md="2" sm="3">
              <b-button block variant="primary" @click="baixarModeloinscricao">
                &nbsp;&nbsp;<span>Baixar Modelo Inscrição</span>
              </b-button>
            </b-col>
            <b-col v-show="exibe_importacao" sm="3">
              <b-button block variant="success" @click="chamaUpload()" >
                &nbsp;&nbsp;<span>Importar Inscrições</span>
              </b-button>
              <b-form-file v-model="arquivo_inscricao" id="file" v-on:change="uploadArquivo($event)" accept="text/csv" class="mt-3" plain style="display: none;"></b-form-file>
            </b-col>
          </b-row>
        </b-card-body>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                  class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th tabindex="0" scope="col">CPF</th>
                      <th tabindex="0" scope="col">Nome</th>
                      <th tabindex="0" scope="col">Data de Inscrição</th>
                      <th tabindex="0" scope="col">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="participantes.data !== undefined">
                    <tr class="action" v-for="participante in participantes.data" :key="participante.id_user">
                      <td>{{ participante.user_participante.cpf }}</td>
                      <td tabindex="0">{{ participante.nome }}</td>
                      <td tabindex="0">
                        {{ participante.created_at }}
                      </td>
                      <td>
                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Visualizar"
                          @click="visualizarParticipante(participante.questionario_respondido_id)">
                          <i class="fa fa-search"></i>
                        </b-button>
                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Editar"
                          @click="editarParticipante(participante.questionario_enviado_id)">
                          <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button tabindex="0" class="btn btn-sm btn-danger action" title="Excluir"
                          @click="excluirParticipante(participante.id)">
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="9" tabindex="0">Nenhum registro de usuários...</td>
                    </tr>
                  </tbody>
                </table>
                <pagination tabindex="0" v-show="participantes.data !== undefined" :totalPorPagina="totalPorPagina"
                  :resource="resource" :filtros="filtros"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>

        <!-- Modal com formulário de nome, cpf e email -->
        <b-modal v-model="modalCadastrar" title="Cadastrar Participante" size="lg">
          <b-card>
            <b-card-body>
              <b-row>
                <b-col sm="12">
                  <b-form-group label="Nome:" for="nome">
                    <b-form-input id="nome" v-model="form_participante.nome" type="text" class="form-control"
                      placeholder="Nome do Participante" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label="CPF:" for="cpf">
                    <b-form-input id="cpf" v-model="form_participante.cpf" v-mask="'###.###.###-##'" type="text"
                      class="form-control" placeholder="CPF do Participante" />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="E-mail:" for="email">
                    <b-form-input id="email" v-model="form_participante.email" type="text" class="form-control"
                      placeholder="E-mail do Participante" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-button block variant="primary" @click="cadastrarParticipante">
                    <i class="fa fa-check"></i>&nbsp;&nbsp;<span>Cadastrar</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-modal>

      </b-card>
    </span>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import moment from 'moment'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect,
    moment
  },
  created() {
    if (!this.validaPerfil()) {
      this.$router.push('/')
    }
    this.loadConferencia()
  },
  data() {
    return {
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      totalPorPagina: 50,
      resource: 'delegacao',
      show: false,
      filtros: {
        filter: '',
        data_inicio: null,
        data_final: null,
      },
      arquivo_inscricao: null,
      exibe_importacao: false,
      formulario_servico_id: null,
      modalCadastrar: false,
      form_participante: {
        nome: '',
        cpf: '',
        email: ''
      }
    }
  },
  computed: {
    participantes() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          let data = this.$store.state.pagination.getList

          return data
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    participante() {
      return this.$store.state.participante.participante
    },

  },
  watch: {
    //
  },
  methods: {
    validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, '');
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

      let soma = 0;
      for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
      let resto = 11 - (soma % 11);
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.charAt(9))) return false;

      soma = 0;
      for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
      resto = 11 - (soma % 11);
      if (resto === 10 || resto === 11) resto = 0;
      return resto === parseInt(cpf.charAt(10));
    },
    pesquisar() {
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    limpar() {
      this.filtros = { filter: null, data_inicial: null, data_final: null }
      this.pesquisar()
    },
    loadConferencia() {
      Vue.http.get('api/conferencia-atual').then(response => {
        let conferencia = response.body.data[0]

        this.exibe_importacao = conferencia.configuracao_conferencia[0].permite_importar_participantes
        this.formulario_servico_id = conferencia.configuracao_conferencia[0].formulario.formulario_servico_id
      })
    },
    validaPerfil() {
      let perfil = this.$store.state.perfil.perfil
      if (perfil.is_admin_local) {
        return true
      }
      return false
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    uploadArquivo(evento){
      console.log('caiaaaaa')
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (arquivo[0].type !== 'text/csv') {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Arquivo de importação inválido', 'Erro!', 7000)
          return false
      }

      this.show = true

      let reader = new FileReader()

      reader.onload = (evento) => {
          this.arquivo_inscricao = evento.target.result
          this.enviarInscricoes()
      }

      reader.readAsDataURL(arquivo[0])
    },
    chamaUpload: ()=> {document.getElementById('file').click()},
    enviarInscricoes(){
      let dados = {
        formulario_servico_id:  this.formulario_servico_id,
        arquivo_inscricao: this.arquivo_inscricao
      }

      Vue.http.post('api/participante/importar/csv', dados).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.arquivo_inscricao = null
          this.show = false
          this.pesquisar()
        }else{
          this.arquivo_inscricao = null
          this.show = false
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta!', 7000)
        }
      }).catch(e => {
          this.arquivo_inscricao = null
          this.show = false
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Erro ao importar participantes! verifique o arquivo enviado.', 'Alerta!', 7000)
      })

    },
    visualizarParticipante(id) {
      Vue.http.get('api/formulario/visualizarResposta/' + id, {}).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(e => { })
    },
    editarParticipante (id) {
      Vue.http.get('api/formulario/editarResposta/' + id, {}).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(e => { })
    },
    baixarModeloinscricao() {
      window.location.href = process.env.ROOT_API1 + 'api/formulario/baixarModeloinscricao/' + this.formulario_servico_id
    },
    abrirModalCadastrar() {
      this.modalCadastrar = true
    },
    cadastrarParticipante() {
      const {nome, cpf, email} = this.form_participante;
      // Valida o preenchimento dos campos
      if (!nome || !cpf || !email) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Preencha todos os campos!', 'Alerta!', 7000)
        return
      }

      if (!this.validarCPF(cpf)) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('CPF inválido! Informe um CPF com 11 dígitos válidos.', 'Alerta!', 7000)
        return
      }

      Vue.http.post('api/formulario/inscricao/cadastrar/' + this.conferencia_id, this.form_participante).then(response => {
        if (response.body.success) {
          window.open(response.body.data.url_inscricao, '_blank');
          this.modalCadastrar = false
        }else{
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta!', 7000)
        }
      }).catch(e => {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error(e.body.msg, 'Alerta!', 7000)
      })
    },
    excluirParticipante(id) {
      this.$bvModal.msgBoxConfirm('Deseja realmente excluir a inscrição?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/participante/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success('Inscrição excluída com sucesso!', 'Sucesso!', 7000)
              this.pesquisar()
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error('Erro ao excluir inscrição!', 'Alerta!', 7000)
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/delegacao/Delegacao.vue